function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import * as React from "react";
var SvgYtIcon = function SvgYtIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 37 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_18282_116280",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 37,
    height: 27
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.4733 4.92966C35.0649 3.38208 33.8688 2.16188 32.3518 1.74522C29.5804 0.971436 18.4949 0.971436 18.4949 0.971436C18.4949 0.971436 7.40929 0.971436 4.63789 1.71546C3.15009 2.13212 1.92484 3.38208 1.51642 4.92966C0.787109 7.75696 0.787109 13.6199 0.787109 13.6199C0.787109 13.6199 0.787109 19.5126 1.51642 22.3101C1.92484 23.8577 3.12092 25.0779 4.63789 25.4946C7.43846 26.2683 18.4949 26.2683 18.4949 26.2683C18.4949 26.2683 29.5804 26.2683 32.3518 25.5243C33.8688 25.1077 35.0649 23.8875 35.4733 22.3399C36.2026 19.5126 36.2026 13.6496 36.2026 13.6496C36.2026 13.6496 36.2318 7.75696 35.4733 4.92966Z",
    fill: "#FF0000"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_18282_116280)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -10.7773,
    y: -3.36523,
    width: 58.5443,
    height: 33.9701,
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8809 7.68091V18.3176L23.3617 13.2582L14.8809 7.68091Z",
    fill: "white"
  })));
};
export default SvgYtIcon;